import http from "../utils/http-common";

const baseHistoryPath = "/api/flare-history";

export const getHistory = (companyId: string, query: string) => {
  return http.get(`${baseHistoryPath}/${companyId}?${query}`);
};

export const getOptionsFilter = (companyId: string, query: string) => {
  return http.get(`${baseHistoryPath}/options/filter-flare-logs/${companyId}?${query}`);
};
